module.exports = __webpack_public_path__ + "static/media/magnifying_glass.8146022f.svg";